import { Component, OnInit } from '@angular/core';
import { User } from '../../_models/user';
import { Router, ActivatedRoute } from '@angular/router';
import { ApiIntegration } from '../../_services/api.integration';
import { AlertService } from '../../_services/alert.service';

@Component({
  selector: 'app-view-ao-seller',
  templateUrl: './view-ao-seller.component.html',
  styleUrls: ['./view-ao-seller.component.scss'],
})
export class ViewAoSellerComponent implements OnInit {
  viewSeller: any = {};
  constructor(private route: ActivatedRoute, private router: Router, public user: User, private alertService: AlertService, private api: ApiIntegration) {
    this.api.getCustomerSellerById(this.route.snapshot.params['id']).subscribe((data: any = []) => {
      this.viewSeller = data;
    }, err => {
      this.alertService.error('Error', err);
    });
  }

  ngOnInit() { }
  editSellers() {
    this.router.navigate(['/admin/editAoSeller/' + this.viewSeller.sellerId]);
  }
}
